'use client'

import {pauseAndMute, playAndUnmute} from '@app/components/game-player/game-functions'
import useSearchStore from '@app/components/search-section/store/search-store'
import clsx from 'clsx'
import {ReactNode, useEffect, useRef, useState} from 'react'
import {usePlayButton} from '../game-image-and-play-btn/play-btn/play-button-context'
import {useFullScreen} from '../actions-section/buttons/full-screen/full-screen-provider'
import s from './style.module.scss'

type Props = {
  children: ReactNode
  className?: string
}

const GameScreenWrapper = ({className, children}: Props) => {
  const gameContainerRef = useRef<HTMLDivElement>(null)
  const [isGamePaused, setIsGamePaused] = useState(false)
  const {isFocused} = useSearchStore()
  const {gameScreenShown} = usePlayButton()
  const {isFullScreen} = useFullScreen()

  useEffect(() => {
    if (isFocused) {
      setIsGamePaused(true)
      pauseAndMute()
    }
  }, [isFocused])

  const handlePlayAndUnmute = () => {
    setIsGamePaused(false)
    if (gameScreenShown) {
      playAndUnmute()
    }
  }

  return (
    <div
      ref={gameContainerRef}
      className={clsx(className, {
        [s.fullscreen]: isFullScreen,
      })}
    >
      {children}
      {isGamePaused && gameScreenShown && (
        <div className='w-full h-full bg-transparent z-50 absolute top-0 left-0' onClick={handlePlayAndUnmute} />
      )}
    </div>
  )
}

export default GameScreenWrapper
